import type { FulfillmentOrderLine } from "../types";
import { parseConfirmationDayExpression } from "./confirmationEntryParser";
import { formatConfirmationDecimal } from "./confirmationDecimalDisplay";

/** 已存确认行未记录人数的自动/手填来源，角色与数量相同也不能推断。 */
export function confirmationTablePeopleSource(line: FulfillmentOrderLine): string {
  return line.unit === "人" ? "已存人数" : "来源未知";
}

/** 来源只读取已存来源类型和核价关联，不按费用分类推断。 */
export function confirmationTableSourceLabel(line: FulfillmentOrderLine): string {
  if (line.sourceBudgetLineId) return "核价快照";
  if (line.sourceType === "manual") return "人工录入";
  if (line.sourceType === "history") return "历史导入";
  return line.sourceType?.trim() || "来源未知";
}

/** 只有明确的单项单次规范快照才展示整项公式，历史其他因素仍完整保留。 */
export function isConfirmationTableLumpSum(line: FulfillmentOrderLine): boolean {
  const spec = line.itemSpecSnapshot?.normalize("NFKC").replace(/\s/gu, "").replace(/[xX*]/gu, "×");
  return line.unit === "项" && spec === "项×次"
    && formatConfirmationDecimal(line.quantity) === "1" && formatConfirmationDecimal(line.billingCount) === "1";
}

/** 已存日次转换为中文范围，未知表达和日期按原值回退。 */
export function confirmationTableDayScope(line: FulfillmentOrderLine): string {
  const parsed = line.dayExpression ? parseConfirmationDayExpression(line.dayExpression) : null;
  const days = parsed?.numbers || line.dayNumbers || [];
  if (days.length) {
    const ordered = [...new Set(days)].sort((a, b) => a - b);
    const continuous = ordered.every((day, index) => index === 0 || day === ordered[index - 1] + 1);
    return continuous && ordered.length > 1
      ? `第${ordered[0]}至第${ordered.at(-1)}天`
      : `第${ordered.join("、")}天`;
  }
  const from = line.serviceDateFrom || line.serviceDates?.[0];
  const to = line.serviceDateTo || line.serviceDates?.at(-1);
  return line.dayExpression || [...new Set([from, to].filter(Boolean))].join(" 至 ") || "—";
}

/** 用车用途只读取明确的资源选择语义，不从车型或自由文字猜测。 */
export function confirmationTableBusScope(line: FulfillmentOrderLine): string {
  const purpose = line.resourceSelection?.kind === "bus"
    ? { pickup: "单接", dropoff: "单送", local_charter: "当地用车", transfer: "原段合计" }[line.resourceSelection.entrySemantic]
    : null;
  return [confirmationTableDayScope(line), purpose].filter(Boolean).join(" · ");
}
